export default class Header {
    constructor() {
        this.body = document.querySelector('body');
        this.header = document.querySelector('header');

        this.menu = this.header.querySelector('.fullmenu')
        this.btnOpenMenu = this.header.querySelector('.btnOpenMenu')
        this.btnCloseMenu = this.header.querySelector('.btnCloseMenu')
        
        this.btnsOpenModalPortal = document.querySelectorAll('.btnOpenModalPortal')
        this.modalPortal = document.querySelector('.modal--portal')
        this.btnCloseModalPortal = this.modalPortal.querySelector('.btnCloseModalPortal')

        // this.searchBtns = this.header.querySelectorAll('.btnBusca');
        // this.modalBusca = document.querySelector('.modalBusca');

        // this.btMenuMobile = this.header.querySelector('.menuMobile');
        // this.menu = this.header.querySelector('.menu');
        // this.submenus = this.menu.querySelectorAll('.submenu');


        this.ready();
        this.hoverMenu();
        this.scrollHeader();
        this.actionMenu();
        this.searchModal();
        
    }

    ready() {

        this.btnsOpenModalPortal.forEach(btn => {
            btn.addEventListener('click', () => {
                this.modalPortal.classList.add('active')
                this.btnCloseModalPortal.addEventListener('click', () => {
                    document.querySelector('.modal--portal.active').classList.remove('active')
                })
            })
        })

    }

    hoverMenu() {

        const allLinks = this.menu.querySelectorAll('.menu-item-has-children > a');

        allLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();

                // Alterna a classe 'active' no item pai
                const parentItem = link.parentNode;
                parentItem.classList.toggle('active');
            });
        });

    }

    actionMenu() {

        this.btnOpenMenu.addEventListener('click', () => {
            this.menu.classList.toggle('active')
        })
        
        this.btnCloseMenu.addEventListener('click', () => {
            this.menu.classList.toggle('active')
        })

    }

    scrollHeader() {
        document.addEventListener('scroll', (e) => {
            let scrollBarPosition = window.scrollY;
            if (scrollBarPosition > 120) {
                this.header.classList.add('scroll');
            } else {
                this.header.classList.remove('scroll');
            }
        });

        if(this.body.classList.contains('hasHome')) {
            this.header.addEventListener('mouseover', () => {
                this.header.classList.remove('noWhite');
            });
            
            this.header.addEventListener('mouseout', () => {
                this.header.classList.add('noWhite');
            });
        }

    }

    searchModal() {

        const btnActionSearchModal = this.header.querySelectorAll('.btnActionSearch')
        const modalSearch = this.header.querySelector('.modal-busca')

        btnActionSearchModal.forEach(el => {
            el.addEventListener('click', () => {
                modalSearch.classList.toggle('active')
            })
        })

    }

}
new Header();
